import { PropTypes } from 'react-desc';

var searchBoxProps = {
  /** Set of Properties attached to the main container */
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),

  /** html class attribute */
  className: PropTypes.string.description('html class attribute'),

  /** ref to the components container */
  innerRef: PropTypes.object.description('ref to the components container'),

  /** Set style to the search box */
  style: PropTypes.object.description('Set style to the search box'),

  /** search property */
  property: PropTypes.string.description('search property'),

  /** Placeholder for the search box */
  placeholder: PropTypes.string.description('Placeholder for the search box'),

  /** Whether to trigger the search once the enter is pressed */
  searchOnEnter: PropTypes.bool.description('Whether to trigger the search once the enter is pressed'),

  /** Whether to clear the input on search */
  clearOnSearch: PropTypes.bool.description('Whether to clear the input on search'),

  /** function triggered once in the search box a keyboard key is released */
  onKeyUp: PropTypes.func.description('function triggered once in the search box a keyboard key is released'),

  /** function triggered once the search action begins (search icon click/ enter keypress) */
  onSearch: PropTypes.func.description('unction triggered once the search action begins (search icon click/ enter keypress)'),

  /** function triggered once the search icon is clicked */
  onSearchButtonClick: PropTypes.func.description('function triggered once the search icon is clicked'),

  /** function that is triggered on change */
  onChange: PropTypes.func.description('function that is triggered on change'),

  /** Function that is triggered on blur */
  onBlur: PropTypes.func.description('Function that is triggered on blur'),

  /** searchbox input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).description('searchbox input value'),

  /** Whether to show an icon or not */
  showIcon: PropTypes.bool.description('Whether to show an icon or not'),

  /** Disables the search input and button */
  disabled: PropTypes.bool.description('Disables the search input and button'),

  /** Disables the search button */
  disableButton: PropTypes.bool.description('Disables the search button'),

  /** whether the input is read only or not */
  readOnly: PropTypes.bool.description('whether the input is read only or not'),

  /** Show clearable button */
  clearable: PropTypes.bool.description('Show clearable button')
};
var navSearchBoxProps = {
  /** searchbox input value */
  value: PropTypes.string.isRequired.description('searchbox input value'),

  /** function that is triggered on change */
  onChange: PropTypes.func.isRequired.description('function that is triggered on change'),

  /** Function that is triggered on blur */
  onBlur: PropTypes.func.description('Function that is triggered on blur'),

  /** triggered on next chevron click */
  onNext: PropTypes.func.isRequired.description('triggered on next chevron click'),

  /** triggered on prev chevron click */
  onPrevious: PropTypes.func.isRequired.description('triggered on prev chevron click'),

  /** function that is triggered on clear button press */
  onClear: PropTypes.func.isRequired.description('function that is triggered on clear button press'),

  /** zero based index to show on search box, -1 hides navigation */
  currentResultIndex: PropTypes.number.isRequired.description('zero based index to show on search box, -1 hides navigation'),

  /** total items to navigate */
  totalResults: PropTypes.number.isRequired.description('total items to navigate'),

  /** Placeholder for the search box */
  placeholder: PropTypes.string.description('Placeholder for the search box')
};

export { navSearchBoxProps, searchBoxProps };
//# sourceMappingURL=props.js.map
